// extracted by mini-css-extract-plugin
export var dropdownContainer = "_55-5";
export var imageContainer = "_55-4";
export var metricsGrid = "_55-2";
export var productDetailContainer = "_55-1";
export var productListContainer = "_55-0";
export var subscriberTableContainer = "_55-3";